/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
    //  console.log(route.display);
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/manager" ||
        route.layout === "/user" ||
        route.layout === "/superadmin" ||
        route.layout === "/tl" 
      ) {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className={`${
                    activeRoute(route.path) === true
                      ? `${route.display} relative flex items-center gap-3 px-3 py-2.5 bg-white/25 rounded-md transition-all duration-150`
                      : `${route.display} relative flex items-center gap-3 px-3 py-2.5 text-white hover:bg-white/10 transition-all duration-150`
                  }`}>
              <li
                className="flex cursor-pointer items-center gap-3 w-full"
                key={index}
              >
                <span
                  className="flex-shrink-0 text-white"
                  style={{ fontSize: '18px', lineHeight: '1' }}
                >
                  {route.icon ? React.cloneElement(route.icon, { className: "h-5 w-5", style: { fontSize: '20px' } }) : <DashIcon className="h-5 w-5" />}
                </span>
                <p
                  className={`text-sm font-normal truncate text-white ${
                    activeRoute(route.path) === true
                      ? "font-medium"
                      : ""
                  }`}
                >
                  {route.name}
                </p>
              </li>
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
